const fields = [
  { field: 'sector', title: 'Sector' },
  { field: 'origin', title: 'Origin of the measure' },
  { field: 'use', title: 'Use or activity' },
  { field: 'nature', title: 'Nature of the measure' },
  { field: 'status', title: 'Status' },
  { field: 'impacts', title: 'Measure impacts to' },
  {
    field: 'impacts_further_details',
    title: 'Measure Impacts to (further details)',
  },
  { field: 'water_body_cat', title: 'Water body category' },
  { field: 'spatial_scope', title: 'Spatial scope' },
  { field: 'country_coverage', title: 'Country' },
  { field: 'descriptors', title: 'Descriptors' },
  {
    field: 'nature_of_physical_modification',
    title: 'Nature of physical modification',
  },
  { field: 'effect_on_hydromorphology', title: 'Effect on hydromorphology' },
  { field: 'ecological_impacts', title: 'Ecological impacts' },
  { field: 'links_to_existing_policies', title: 'Link to existing policies' },
  { field: 'ktms_it_links_to', title: 'KTMs it links to' },
  { field: 'relevant_targets', title: 'Relevant targets' },
  {
    field: 'relevant_features_from_msfd_annex_iii',
    title: 'Relevant features from MSFD Annex III',
  },
  { field: 'msfd_spatial_scope', title: 'MSFD Spatial scope' },
  { field: 'measure_purpose', title: 'Measure purpose' },
  { field: 'measure_location', title: 'Measure location' },
  { field: 'measure_response', title: 'Measure response' },
  { field: 'measure_additional_info', title: 'Measure additional info' },
  { field: 'pressure_type', title: 'Type of pressure' },
  { field: 'pressure_name', title: 'Pressure name' },
  { field: 'ranking', title: 'Ranking' },
  { field: 'region', title: 'Region' },
  { field: 'mspd_implementation_status', title: 'MSPD implementation status' },
  { field: 'shipping_tackled', title: 'Shipping Tackled' },
  { field: 'traffic_separation_scheme', title: 'Traffic separation scheme' },
  { field: 'priority_areas', title: 'Priority Areas' },
  { field: 'approaching_areas', title: 'Approaching Areas' },
  { field: 'precautionary_areas', title: 'Precautionary areas' },
  { field: 'areas_to_be_avoided', title: 'Areas to be avoided' },
  { field: 'future_scenarios', title: 'Future Scenarios' },
  { field: 'source', title: 'Source' },
  { field: 'authority', title: 'Authority' },
  { field: 'general_view', title: 'General View' },
  { field: 'ports', title: 'Ports' },
  { field: 'future_expectations', title: 'Future Expectations' },
  { field: 'safety_manner', title: 'Safety manner' },
  { field: 'objective', title: 'Objective' },
  { field: 'categories', title: 'Categories' },
];

export { fields };
